export const isPsmTraffic = (searchParams: URLSearchParams): boolean =>
    <boolean>(
        (searchParams.get('utm_medium')?.toLowerCase() === 'sop' &&
            searchParams.get('utm_source')?.toLowerCase() === 'fb' &&
            searchParams.get('utm_campaign')?.toLowerCase().includes('prospecting') &&
            searchParams.get('utm_campaign')?.toLowerCase().includes('shop'))
    );

export const isSemTraffic = (searchParams: URLSearchParams): boolean => searchParams.has('gclid');

export const isAffiliateTraffic = (searchParams: URLSearchParams): boolean => {
    const utmSource = searchParams.get('utm_source')?.toLowerCase();
    const utmContent = searchParams.get('utm_content')?.toLowerCase();

    return !!(utmSource && ['ran', 'awin'].includes(utmSource) && utmContent === 'lockshop');
};

export const isShop2ClubAbTestExcludedTraffic = (searchParams: URLSearchParams): boolean => {
    const failConditions = [isAffiliateTraffic(searchParams), isPsmTraffic(searchParams)];
    return failConditions.some(Boolean);
};
